export default [
    {
        path: 'estorno-dispensacao',
        component: () => import(
            /* webpackChunkName: 'farmacia-estorno-dispensacao' */
            '@/views/farmacia/estorno-dispensacao/Index'
        ),
        redirect: 'estorno-dispensacao/index',
        children: [
            {
                name: 'farmacia-estorno-dispensacao-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'farmacia-estorno-dispensacao' */
                    '@/views/farmacia/estorno-dispensacao/List.vue'
                ),
            },
        ],
    },
]